module.exports = __webpack_public_path__ + "img/timeline_mainevent-13.0a494faf.jpg";